import React from "react";
import ProfileContainer from "../components/ProfileContainer";
import {useTalent} from "../../../providers/TalentProvider";
import {Button, Checkbox, Divider} from "antd";
import {CheckCircleTwoTone, CloseCircleTwoTone, QuestionCircleOutlined} from "@ant-design/icons";
import {CommitmentOptions} from "../../talent-preferences/components/DashboardPreferences";
import {Link} from "react-router-dom";

const TalentProfileWorkStatus = (props) => {

    const {talent} = useTalent();

    return (
        <div id="work-status" className="pt-2 pb-8">
            <ProfileContainer>
                <h4 className="textbold text-lg pb-6">Work Status</h4>

                <div className="flex flex-col items-start gap-2">
                    <div className="flex flex-col items-start gap-3">
                        {!!talent?.supplier_client?.id ? (
                            <div className="flex flex-col items-start gap-6">
                                <p className="text-sm font-semibold">
                                    Talent is employed by an agency and made available for hire through Wripple's platform.
                                </p>
                                <div className="flex flex-row items-center gap-4">
                                    <Link
                                        target="_blank" to={`/agency-profiles/${talent.supplier_client.id}`}
                                        className="flex items-center justify-start">
                                        <img alt={''} src={talent?.supplier_client.logo_path}
                                             className="rounded-full h-24 w-24 max-h-24 max-w-24 object-contain"/>
                                    </Link>
                                    <div className="flex flex-col items-start justify-center gap-2.5">
                                        <p className="text-sm">
                                            Agency: {talent.supplier_client.name}
                                        </p>

                                        <Link target="_blank" to={`/agency-profiles/${talent.supplier_client.id}`}>
                                            <Button type="primary" className="px-4">
                                                Visit Agency Profile
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                                <p className="text-sm">
                                    Note: Agencies are carefully selected as eligible talent suppliers on Wripple based on client case studies, the quality of their talent, and the distinctiveness of their service offerings.
                                </p>
                            </div>
                        ) : (
                            <React.Fragment>
                                <div className="flex flex-col items-start gap-5">
                                    <div className="flex flex-row items-center gap-4">
                                        <div className="flex gap-1.5 items-center mr-2">
                                            <CheckCircleTwoTone style={{fontSize: 24}}
                                                                twoToneColor={TB.config('color.success-darker')}/>
                                            <p className="text-sm font-semibold whitespace-nowrap">
                                                Vetted Talent
                                            </p>
                                        </div>
                                        <p className="text-xs font-medium">
                                            Talent has been vetted by Wripple through a review of work history,
                                            experience
                                            and skills.
                                        </p>

                                    </div>
                                    <div className="flex flex-row items-center gap-4">
                                        {CommitmentOptions[talent.talent_commitment_level] && (
                                            <div className="py-1 px-3 bg-wripplePrimaryRuleBlue cursor-default">
                                                <p className="text-sm whitespace-nowrap">{CommitmentOptions[talent.talent_commitment_level]?.title}</p>
                                            </div>
                                        )}
                                        <p className="text-xs font-medium">
                                            {CommitmentOptions[talent.talent_commitment_level]?.display}
                                        </p>

                                    </div>

                                </div>
                                <Divider className="my-3"/>
                                <div className="flex flex-col items-start gap-3">
                                    <p className="font-semibold text-sm">
                                        Types of Work – Job Classification
                                    </p>
                                    <div className="flex flex-col items-start gap-5">
                                        <div className="flex flex-row gap-4 items-start">
                                            <div className="flex flex-col items-center justify-center h-8">
                                                {talent.hasW2Classification() ? (
                                                    <CheckCircleTwoTone
                                                        style={{fontSize: 22}}
                                                        twoToneColor={TB.config('color.success-darker')}/>
                                                ) : (
                                                    <CloseCircleTwoTone
                                                        style={{fontSize: 22}}
                                                        twoToneColor={TB.config('color.danger')}/>
                                                )}
                                            </div>
                                            <div className="flex flex-col items-start gap-2">
                                                <div className="flex flex-row items-center gap-4 h-8">
                                                    <p className="font-medium text-sm">
                                                        Interested in W2 hourly assignments
                                                    </p>
                                                    {talent.hasW2Classification() && (
                                                        <div className="px-3 py-1 bg-wrippleLightSemitransparent">
                                                            <p className="text-sm">W2 Hourly</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <p className="text-xs">
                                                    W2 hourly projects involve staffing assignments where contractors are paid
                                                    hourly, integrated into a team, and work under the client's direction.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex flex-row gap-4 items-start">
                                            <div className="flex flex-col items-center justify-center h-8">
                                                {talent.has1099Classification() ? (
                                                    <CheckCircleTwoTone
                                                        style={{fontSize: 22}}
                                                        twoToneColor={TB.config('color.success-darker')}/>
                                                ) : (
                                                    talent.incomplete1099Classification() ? (
                                                        <QuestionCircleOutlined
                                                            style={{fontSize: 22}}
                                                            className="text-gray-500"/>
                                                    ) : (
                                                        <CloseCircleTwoTone
                                                            style={{fontSize: 22}}
                                                            twoToneColor={TB.config('color.danger')}/>
                                                    )
                                                )}
                                            </div>
                                            <div className="flex flex-col items-start gap-2">
                                                <div className="flex flex-row items-center gap-4 h-8">
                                                    <p className="font-medium text-sm">
                                                        {talent.incomplete1099Classification() ?
                                                            'Worker eligibility for 1099 assignments has not yet been verified – will be determined during the project interview process.' :
                                                            'Verified as having the qualifications for 1099 projects'
                                                        }
                                                    </p>
                                                    {talent.has1099Classification() && (
                                                        <div className="px-3 py-1 bg-wrippleLightSemitransparent">
                                                            <p className="text-sm">1099</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <p className="text-xs">
                                                    1099 projects are deliverable-based freelance assignments, ranging from
                                                    short-term to long-term, where freelancers complete work with minimal
                                                    supervision.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>




                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileWorkStatus;